import { useRef, useEffect } from 'react';
import classNames from 'classnames/bind';
import gsap from 'gsap';

import styles from './index.module.scss';
import logo from '../../../asset/images/global/logo_white.png';

const cx = classNames.bind(styles);

const S05 = () => {
  const containerRef = useRef();
  const word01Ref = useRef();
  const word02Ref = useRef();
  const word03Ref = useRef();
  const word04Ref = useRef();
  const word05Ref = useRef();
  const word06Ref = useRef();
  const word07Ref = useRef();
  const word08Ref = useRef();
  const word09Ref = useRef();
  const word10Ref = useRef();
  const word11Ref = useRef();
  const word12Ref = useRef();

  useEffect(() => {
    gsap
      .timeline({
        scrollTrigger: {
          trigger: containerRef.current,
          scrub: true,
          pin: true,
          start: 'top top',
          end: '+=100%',
          pinSpacing: true,
        },
      })
      .to(word01Ref.current, { className: cx('enable') })
      .to(word02Ref.current, { className: cx('enable') })
      .to(word03Ref.current, { className: cx('enable') })
      .to(word04Ref.current, { className: cx('enable') })
      .to(word05Ref.current, { className: cx('enable') })
      .to(word06Ref.current, { className: cx('enable') })
      .to(word07Ref.current, { className: cx('enable') })
      .to(word08Ref.current, { className: cx('enable') })
      .to(word09Ref.current, { className: cx('enable') })
      .to(word10Ref.current, { className: cx('enable') })
      .to(word11Ref.current, { className: cx('enable') })
      .to(word12Ref.current, { className: cx('enable') });
  }, []);
  return (
    <section ref={containerRef} className={cx('container')}>
      <div className={cx('wrapper')}>
        <p className={cx('desc')}>
          <span ref={word01Ref}>Premium </span>
          <span ref={word02Ref}>Family </span>
          <span ref={word03Ref}>Cosmetics </span>
          <span ref={word04Ref}>from </span>
          <span ref={word05Ref}>Korea,</span>
          <br />
          <span ref={word06Ref}>made </span>
          <span ref={word07Ref}>for </span>
          <span ref={word08Ref}>joyful </span>
          <span ref={word09Ref}>moments </span>
          <span ref={word10Ref}>with </span>
          <span ref={word11Ref}>your </span>
          <span ref={word12Ref}>family</span>
        </p>
        <img src={logo} alt="LEVRAI" className={cx('logo')} />
      </div>
    </section>
  );
};

export default S05;
